# toolkit/form_elements#textarea__include-a-guide
$(document).on "click", ".js-toggle-textarea-guide", (e) ->
  wrapper = $(@).closest(".textarea-guide-header-wrapper")
  eventName = $(@).data("toggle-ga-event")
  wrapper.toggleClass("active")
  $(@).trigger("textareaGuide:toggled")
  if eventName.length > 0
    state = if wrapper.hasClass("active") then "active" else "inactive"



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/textarea.js.coffee